import React, { useState } from "react";
import { motion } from "framer-motion";
import "bootstrap-icons/font/bootstrap-icons.css";

export default function PrefixesForm() {
  const [formData, setFormData] = useState({
    employee: "EMP",
    clients: "CLI",
    invoice: "INV",
    tickets: "TIC",
    candidate: "CAND",
    job: "JOB",
    referral: "REF",
    assets: "AST",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value.toUpperCase(),
    }));
  };

  const fields = [
    "employee",
    "invoice",
    "candidate",
    "referral",
    "clients",
    "tickets",
    "job",
    "assets",
  ];

  return (
    <motion.div
      className="card container py-3"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      {/* TITLE */}
      <motion.h5
        className="fw-semibold mb-3 text-primary"
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.1 }}
      >
        Prefixes
      </motion.h5>

      {/* CARD */}
      <motion.div
        className="card shadow-sm border-0 p-4"
        initial={{ opacity: 0, scale: 0.97 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.15 }}
      >
        <div className="row">
          {fields.map((key, i) => (
            <motion.div
              key={key}
              className="col-md-6 mb-3"
              initial={{ opacity: 0, y: 15 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.05 }}
            >
              <label className="form-label text-capitalize">
                {key}
              </label>

              <motion.input
                name={key}
                value={formData[key]}
                onChange={handleChange}
                className="form-control"
                whileFocus={{ scale: 1.02 }}
              />
            </motion.div>
          ))}
        </div>

        {/* BUTTONS */}
        <motion.div
          className="d-flex justify-content-end gap-2 mt-3"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
        >
          <motion.button
            whileTap={{ scale: 0.9 }}
            className="btn btn-outline-danger"
          >
            Cancel
          </motion.button>

          <motion.button
            whileTap={{ scale: 0.9 }}
            className="btn btn-outline-primary"
          >
            Save
          </motion.button>
        </motion.div>
      </motion.div>
    </motion.div>
  );
}